import { render, staticRenderFns } from "./upImgDetail.vue?vue&type=template&id=1efbe6e0&scoped=true&"
import script from "./upImgDetail.vue?vue&type=script&lang=js&"
export * from "./upImgDetail.vue?vue&type=script&lang=js&"
import style0 from "./upImgDetail.vue?vue&type=style&index=0&id=1efbe6e0&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efbe6e0",
  null
  
)

export default component.exports